import React from 'react';

export default class WarningBoat extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isChecked: this.props.formData
        };
    }

    handleClose = () => {
        this.props.unmount();
    };

    render() {
        return (
            <div className="messageBox _3yL3MHCqkbDetrH4PCQ6a8 _2nd5IFTQ8VYuc7GsxIuCJ7">
                <span>
                    <div className="_8wsdbvgNuxake7CrAufWp">
                        <div className="_2Cn2Tjrk4xoa7zVGe4Uy_G m6Smdm24QK8MW4NlxUbuw  ">
                            <span className="fa _1bFBUJ5g0HO7w0plzpIt8y"></span>
                            <div className="_1hSQVzPPIvQKhkBXB3sM_2"><p className="_2W8eAWPB1SDTN9aLK5IocC">{this.props.label}</p></div>
                            <div className="_3O6nkcMuweiMNluqSqnxba"><span onClick={this.handleClose} className="fa _2xnpTL8bgjiILDe5YkGals"></span></div>
                        </div>
                    </div>
                </span>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// ./src/components/forms/fields/WarningBoat.js